import { motion } from "framer-motion";
import { FAITHS, dailyLine } from "@/lib/lunelle-data";

const today = () => new Date().toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" });

export const FaithPills = ({ faith, onChange, prefix }) => (
  <div className="flex flex-wrap gap-2">
    {FAITHS.map((f) => (
      <button key={f.id} onClick={() => onChange(f.id)} data-testid={`${prefix}-faith-${f.id}`}
        className={`relative rounded-full px-4 py-2 text-sm font-medium transition-colors duration-300 ${faith === f.id ? "text-[#FBF5EE]" : "border border-[#C86D51]/25 text-[#5C4A42] hover:border-[#9E4429] hover:text-[#2C221E]"}`}>
        {faith === f.id && <motion.span layoutId={`${prefix}-faith-pill`} className="absolute inset-0 rounded-full bg-[#9E4429]" transition={{ type: "spring", stiffness: 300, damping: 30 }} />}
        <span className="relative">{f.name}</span>
      </button>
    ))}
  </div>
);

export const DailyVerse = ({ faith, size = "lg" }) => {
  const { faith: f, line } = dailyLine(faith);
  const big = size === "xl";
  return (
    <motion.figure key={faith} initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }} data-testid="daily-verse">
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#7A665C]" data-testid="daily-verse-date">{today()} · {f.name}</p>
      <blockquote className={`mt-6 font-serif font-light italic leading-[1.1] tracking-tight text-[#2C221E] ${big ? "text-4xl sm:text-6xl lg:text-7xl" : "text-3xl sm:text-5xl"}`} data-testid="daily-verse-text">
        &ldquo;{line.text}&rdquo;
      </blockquote>
      <figcaption className="mt-6 text-sm font-semibold text-[#9E4429]" data-testid="daily-verse-ref">{line.ref}</figcaption>
    </motion.figure>
  );
};
